import { apiSlice } from "../../../api/apiSlice";
import { COACHING_GOAL, COACHING_GOAL_REVIEW, COACHING_GOAL_SETTING } from "../../../constants";


export const CoachingGoalSlice = apiSlice.injectEndpoints({
    endpoints: (builder:any) => ({
        getCoachingGoal: builder.query({
            query: (data:any) => ({
                url: COACHING_GOAL,
                method: "GET",
                params: data,
            }),
            providesTags: ["CoachingGoal"],
        }),
        createCoachingGoal: builder.mutation({
            query: (data:any) => ({
                url: COACHING_GOAL,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ['Coaching','Activity'],
        }),
        coachingGoalSetting: builder.mutation({
            query: (data:any) => ({
                url: COACHING_GOAL_SETTING,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["CoachingGoalInfo","CoachingGoal"],
        }),
        coachingGoalReview: builder.mutation({
            query: (data:any) => ({
                url: COACHING_GOAL_REVIEW,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["CoachingGoalInfo","CoachingGoal"],
        }),
    }),
});

export const { useGetCoachingGoalQuery, useCreateCoachingGoalMutation, useCoachingGoalSettingMutation, useCoachingGoalReviewMutation } = CoachingGoalSlice;
